<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <template v-slot:header>
                <h5>Edit Tipe Barang</h5>
            </template>
            <b-form @submit.prevent="openModalConfirm">
                <div class="form-content-wrapper">
                    <h6 class="form-title">DATA UMUM</h6>
                    <b-form-group label="Jenis Barang">
                        <multiselect name="jenisBarang"
                            :value="jenisBarang.find(item => item.id == input.jenisBarang) || null"
                            :options="jenisBarang" :internal-search="true" :allow-empty="false"
                            deselect-label="" select-label="" label="name" track-by="id"
                            placeholder="Pilih Jenis Barang"
                            @input="input.jenisBarang = $event ? $event.id : null" />
                    </b-form-group>
                    <b-form-group label="Merk Barang">
                        <multiselect name="merkBarang"
                            :value="merkBarang.find(item => item.id == input.merkBarang) || null"
                            :options="merkBarang" :internal-search="true" :allow-empty="false"
                            :disabled="!input.jenisBarang" deselect-label="" select-label=""
                            label="name" track-by="id" placeholder="Pilih Merk Barang"
                            @input="input.merkBarang = $event ? $event.id : null" />
                    </b-form-group>
                    <b-form-group label="Nama Tipe Barang">
                        <b-form-input v-model="input.tipeBarang" name="tipeBarang" required></b-form-input>
                        <p class="mb-0 smallText text-muted" v-if="panduanNamaTipe">Panduan Nama Tipe: <bold>{{panduanNamaTipe.name}}</bold></p>
                    </b-form-group>
                    <b-form-group v-if="input.jenisBarang != null && input.jenisBarang == 251" label="Berat Emas">
                        <b-input-group append="Gr">
                            <b-form-input v-model="input.berat" name="diatasJasa1" step="0.01" type="number" @blur="roundPersen()"></b-form-input>
                        </b-input-group>
                    </b-form-group>
                    
                    <b-form-group label="Kelompok Barang">
                        <multiselect v-model="input.kelompok" :options="optKelompok" :internal-search="true" :allow-empty="false" 
                            deselect-label="" select-label="" label="name" track-by="id" />
                    </b-form-group>

                    <b-form-group label="Harga Barang Baru">
                        <b-input-group prepend="Rp.">
                            <b-form-input v-model="input.hargaBarangBaru" name="hargaBarangBaru"></b-form-input>
                        </b-input-group>
                    </b-form-group>
                </div>


                <!-- <div class="form-content-wrapper">
                    <h6 class="form-title">Surat Edaran Tipe Barang</h6>
                    <b-row>
                        <b-col cols="10" md="3">
                            
                                <FormulateForm v-model="pdf">
                                    <FormulateInput v-if="url.length != 0"
                                    id="urlPDF"
                                    name="urlPDF"
                                    ref="urlPDF"
                                    type="file"
                                    :value="url"
                                    help="Format Harus PDF"
                                    accept=".pdf"
                                    validation="mime:application/pdf"
                                    multiple
                                    />

                                    <FormulateInput v-else
                                    type="file"
                                    name="file"
                                    help="Format Harus PDF"
                                    validation="mime:application/pdf"
                                    accept=".pdf"
                                    fileRemove
                                    multiple
                                    />
                                </FormulateForm>

                        </b-col>
                   
                        <b-col cols="2">
                            <div v-if="pdf != null "> 
                                <div v-if="pdf.urlPDF != undefined || pdf.urlPDF != null ">
                                    <div v-for="file of pdf.urlPDF.files">            
                                        <b-button size="sm" class="mb-3" variant="pgiBtn" @click="openModalPreviewPDFTahunKondisi( file.base64 != null ?file.base64 : $baseFilePath + file.file.previewData )">View</b-button>                
                                    </div>
                                </div> 

                                <div v-if="pdf.file != undefined || pdf.file != null ">
                                    <div v-for="file of pdf.file.files">            
                                        <b-button size="sm" class="mb-3" variant="pgiBtn" @click="openModalPreviewPDFTahunKondisi( file.base64 != null ?file.base64 : $baseFilePath + file.file.previewData )">View</b-button>                
                                    </div>
                                </div> 
                            </div>
                            
                        </b-col> 
                    </b-row>
                </div> -->

                <div class="form-content-wrapper">
                    <h6 class="form-title">STATUS BARANG</h6>
                    <b-form-group>
                        <b-form-select v-model="input.statusBarang" name="statusBarang" required>
                            <template v-slot:first>
                                <b-form-select-option :value="true">AKTIF</b-form-select-option>
                                <b-form-select-option :value="false">NON-AKTIF</b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-form-group>
                </div>
                <!-- <div class="form-content-wrapper">
                    <h6 class="form-title">TAHUN / GENERASI</h6>
                    <label>Surat Edaran Tahun / Generasi</label>
                    <b-row>
                        <b-col cols="10" md="3">
                         
                                <FormulateForm v-model="pdf1">
                                    <FormulateInput v-if="url1.length != 0"
                                    ref="urlPDF"
                                    name="urlPDF"
                                    type="file"
                                    :value="url1"
                                    help="Format Harus PDF"
                                    accept=".pdf"
                                    validation="mime:application/pdf"
                                    multiple
                                    />

                                    <FormulateInput v-else
                                    type="file"
                                    name="file"
                                    help="Format Harus PDF"
                                    validation="mime:application/pdf"
                                    accept=".pdf"
                                    fileRemove
                                    multiple
                                    />
               
                                </FormulateForm>

                        </b-col>
                        <b-col cols="2">
                            <div v-if="pdf1 != null "> 
                                <div v-if="pdf1.urlPDF != undefined || pdf1.urlPDF != null ">
                                    <div v-for="file of pdf1.urlPDF.files">            
                                        <b-button size="sm" class="mb-3" variant="pgiBtn" @click="openModalPreviewPDFTahunKondisi( file.base64 != null ?file.base64 : $baseFilePath + file.file.previewData )">View</b-button>                
                                    </div>
                                </div> 

                                <div v-if="pdf1.file != undefined || pdf1.file != null ">
                                    <div v-for="file of pdf1.file.files">            
                                        <b-button size="sm" class="mb-3" variant="pgiBtn" @click="openModalPreviewPDFTahunKondisi( file.base64 != null ?file.base64 : $baseFilePath + file.file.previewData )">View</b-button>                
                                    </div>
                                </div> 
                            </div>
                            
                        </b-col>    
                    </b-row>
                    <b-form-group>
                        <b-form-checkbox v-model="hargaSesuaiTahun" name="hargaSesuaiTahun" :disabled="disabled">
                            Harga Berdasarkan Tahun / Generasi
                        </b-form-checkbox>
                    </b-form-group>

                    <b-form-group label="Harga" v-if="!hargaSesuaiTahun">
                        <b-input-group prepend="Rp.">
                            <b-form-input v-model="input.hargaTipeBarang" name="hargaTipeBarang" required></b-form-input>
                        </b-input-group>
                        
                    </b-form-group>
                    <b-tabs v-else class="tab-wrapper" content-class="tab-content-wrapper">
                        <b-tab title="Aktif">
                            <div>
                                <b-button variant="pgiBtn" class="mb-2" name="hargaTahunAddBtn" @click="addHargaTahun"><i
                                        class="fa fa-plus mr-2"></i>Entri Baru</b-button>
                                <HargaTahun v-for="item in input.hargaTahun" v-bind:key="item.index" :hargaTahun="item"
                                    :length="input.hargaTahun.length" :isKendaraan="isKendaraan"
                                    @remove="removeHargaTahun(item.index, item.id)"
                                    @nonAktif="nonAktifHargaTahun(item.index, item.id, item.hargaBpkb, item.hargaKendaraan, item.selectedTahun, item.isActive)"
                                    :idHargaTahun="item.id" 
                                    :filePDF = "item.filePDF"
                                    @changeSEHargaTahun="changeSEHargaTahun"
                                    @openModalPreviewPDFTahunKondisi = "openModalPreviewPDFTahunKondisi" />
                            </div>
                        </b-tab>
                        <b-tab title="Non Aktif">
                            <HargaTahunNonAktif v-for="item in hargaTahunNonAktif" v-bind:key="item.index"
                                :hargaTahun="item" :length="input.hargaTahun.length" :isKendaraan="isKendaraan"
                                @aktif="aktifHargaTahun(item.index, item.id, item.hargaBpkb, item.hargaKendaraan, item.selectedTahun)" />
                        </b-tab>
                    </b-tabs>
                </div> -->


                <!-- <div class="form-content-wrapper">
                    <h6 class="form-title">Foto Pendukung</h6>
                    <b-button variant="pgiBtn" class="mb-2" @click="addFotoPendukung" name="fotoPendukungAddBtn"><i
                            class="fa fa-plus mr-2"></i>Foto Pendukung</b-button>
                    <div class="text-danger mt-2 mb-2" v-show="fotoPendukungError">* Foto Pendukung Maksimal 6 Foto</div>
                    <FotoPendukungTipeBarang v-for="item in input.fotoPendukung" v-bind:key="item.index"
                        :fotoPendukung="item" :foto="foto[item.index]" :length="input.fotoPendukung.length"
                        :minLength="minLengthFotoPendukung" @remove="removeFotoPendukung(item)" @showModalCam="openModalCam"
                        @showModalPreview="openModalPreview" />
                </div> -->

                <!-- <div class="form-content-wrapper">
                    <h6 class="form-title">KONDISI</h6>
                    <b-form-group>
                        <b-form-checkbox v-model="kondisiSesuaiMerk" name="kondisiSesuaiMerk">
                            Mengikuti Kondisi Merk
                        </b-form-checkbox>
                    </b-form-group>

                    <b-table v-if="kondisiSesuaiMerk" bordered hover :fields="fields" :busy="isBusy" :items="kondisiBarang"
                        responsive class="mb-3" show-empty>
                        <template v-slot:empty>
                            Tidak ada data kondisi dari merk yang terpilih atau merk belum dipilih
                        </template>
                        <template v-slot:cell(klasifikasi)="row">
                            <div v-if="row.item.dus !== null">
                                <span v-if="row.item.dus">Dus</span>
                                <span v-else>Non Dus</span>
                            </div>
                            <div v-else>
                                <span v-if="row.item.namaSendiri">BPKB a/n Sendiri</span>
                                <span v-else>BPKB a/n Orang Lain</span>
                            </div>
                        </template>
                        <template v-slot:cell(hargaMaksimal)="row">
                            <div class="text-right no wrap" v-if="row.item.hargaMaksimal == null">
                                {{ $helper.addThousandSeparator(row.item.hargaMaksimal) }} </div>
                            <div class="text-right no wrap text-danger" v-else-if="row.item.hargaMaksimal < 0">Rp.
                                {{ $helper.addThousandSeparator(row.item.hargaMaksimal) }} </div>
                            <div class="text-right no wrap" v-else>Rp.
                                {{ $helper.addThousandSeparator(row.item.hargaMaksimal) }} </div>
                        </template>
                        <template v-slot:cell(nominalAngka)="row">
                            <div class="text-right no wrap" v-if="row.item.nominalAngka == null">
                                {{ $helper.addThousandSeparator(row.item.nominalAngka) }} </div>
                            <div class="text-right no wrap text-danger" v-else-if="row.item.nominalAngka < 0">Rp.
                                {{ $helper.addThousandSeparator(row.item.nominalAngka) }} </div>
                            <div class="text-right no wrap" v-else>Rp.
                                {{ $helper.addThousandSeparator(row.item.nominalAngka) }} </div>
                        </template>
                        <template v-slot:cell(nominalPersen)="row">
                            <div class="text-right no-wrap" v-if="row.item.nominalPersen == null">
                                {{ $helper.addThousandSeparator(row.item.nominalPersen) }} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.nominalPersen < 100">
                                {{ $helper.addThousandSeparator(row.item.nominalPersen) }} %</div>
                            <div class="text-right no-wrap" v-else>{{ $helper.addThousandSeparator(row.item.nominalPersen)
                            }}
                                %</div>
                        </template>
                        <template v-slot:table-busy>
                            <div class="text-center text-danger my-2">
                                <b-spinner class="align-middle"></b-spinner>
                                <strong> Loading data...</strong>
                            </div>
                        </template>
                    </b-table>
                    <div v-else>
                        <label>Surat Edaran Kondisi Barang</label>
                    <b-row>
                        <b-col cols="10" md="3">
                         
                                <FormulateForm v-model="pdf2">
                                    <FormulateInput v-if="url2.length != 0"
                                    ref="urlPDF"
                                    name="urlPDF"
                                    type="file"
                                    :value="url2"
                                    help="Format Harus PDF"
                                    accept=".pdf"
                                    validation="mime:application/pdf"
                                    multiple
                                    />

                                    <FormulateInput v-else
                                    type="file"
                                    name="file"
                                    help="Format Harus PDF"
                                    validation="mime:application/pdf"
                                    accept=".pdf"
                                    fileRemove
                                    multiple
                                    />
                                </FormulateForm>
                        </b-col>
                        <b-col cols="2">
                            <div v-if="pdf2 != null "> 
                                <div v-if="pdf2.urlPDF != undefined || pdf2.urlPDF != null ">
                                    <div v-for="file of pdf2.urlPDF.files">            
                                        <b-button size="sm" class="mb-3" variant="pgiBtn" @click="openModalPreviewPDFTahunKondisi( file.base64 != null ?file.base64 : $baseFilePath + file.file.previewData )">View</b-button>                
                                    </div>
                                </div> 

                                <div v-if="pdf2.file != undefined || pdf2.file != null ">
                                    <div v-for="file of pdf2.file.files">            
                                        <b-button size="sm" class="mb-3" variant="pgiBtn" @click="openModalPreviewPDFTahunKondisi( file.base64 != null ?file.base64 : $baseFilePath + file.file.previewData )">View</b-button>                
                                    </div>
                                </div> 
                            </div>
                            
                        </b-col> 
                    </b-row>
                        <b-button variant="pgiBtn" class="mb-2" name="kondisiAddBtn" @click="addKondisi"><i
                                class="fa fa-plus mr-2"></i>Kondisi</b-button>
                        <Kondisi v-for="item in input.kondisi" v-bind:key="item.index" :kondisi="item"
                            :length="input.kondisi.length" :isKendaraan="isKendaraan"
                            @remove="removeKondisi(item.index, item.id)"
                            :idKondisi="item.id" 
                            :filePDF = "item.filePDF"
                            @changeSEKon="changeSEKon"
                            @openModalPreviewPDFSpekKel = "openModalPreviewPDFTahunKondisi" />
                    </div>
                </div> -->

                <div class="form-wrapper-btn submit-btn-wrapper">
                    <b-button type="submit" name="tipeBarangUpdateBtn" variant="pgiBtn">Update</b-button>
                </div>
            </b-form>
            <ModalWebCam idWebcam="webcam-input-elek" @photoTaken="setResult" />
            <ModalPreview modalId="modal-preview-gadai" :fotoPreview="activeFotoPreview" />
        </b-card>
        <ModalConfirm id="modal-confirm-edit" title="Confirm Edit Tipe Barang" :isSubmitting="isSubmitting"
            desc="Apakah anda yakin untuk mengubah tipe barang ini?" @submit="onSubmit" />
        <ModalConfirm id="modal-confirm-non-aktif" title="Confirm Non Aktif Harga Tahun"
            desc="Apakah anda yakin untuk menonaktifkan tahun tipe barang ini?" @submit="onSubmitNonAktifHargaTahun" />
        <ModalConfirm id="modal-confirm-aktif" title="Confirm Aktifkan Harga Tahun"
            desc="Apakah anda yakin untuk mengaktifkan tahun tipe barang ini?" @submit="onSubmitAktifHargaTahun" />
        <ModalConfirm id="modal-confirm-hapus-tahun" title="Confirm Hapus Harga Tahun"
            desc="Apakah anda yakin untuk menghapus tahun tipe barang ini?" @submit="onSubmitHapusHargaTahun" />
        <ModalConfirm id="modal-confirm-hapus-kondisi" title="Confirm Hapus Kondisi"  
            desc="Apakah anda yakin untuk menghapus kondisi barang ini?" @submit="onSubmitHapusKondisi" />

        <ModalConfirm id="modal-confirm-hapus-foto" title="Confirm Hapus Foto"
            desc="Apakah anda yakin untuk menghapus foto barang ini?" @submit="onSubmitRemoveFoto" />

            <ModalConfirm  id="modal-hapus-se" title="Confirm Hapus SE" desc="SE Akan Terhapus Permanen" @submit=removeSE />
            <ModalConfirm  id="modal-hapus-se-tahun" title="Confirm Hapus SE" desc="SE Akan Terhapus Permanen" @submit=removeSETahun />
            <ModalConfirm  id="modal-hapus-se-kondisi" title="Confirm Hapus SE" desc="SE Akan Terhapus Permanen" @submit=removeSEKondisi />
            

         <!-- MODAL SHOW SE -->
         <b-modal id="modal-SE" size="lg" title="Modal SE">
                <iframe width="100%" height="700" allowfullscreen :src="activePdfPreview" frameborder="0"></iframe>
                <template v-slot:modal-footer="{ cancel }">
                    <b-button variant="secondary" name="closePreviewBtn" @click="cancel()">
                        Close
                    </b-button>
                </template>
        </b-modal>

    </div>
</template>

<script>
import Vue from 'vue'
import VueFormulate from '@braid/vue-formulate'

Vue.use(VueFormulate)
import Kondisi from '../../../components/kondisi/Kondisi'
import HargaTahun from '../../../components/hargatahun/HargaTahun'
import HargaTahunNonAktif from '../../../components/hargatahun/HargaTahunNonAktif'
import EditFotoTipeBarang from '../../../components/tipebarang/EditFotoTipeBarang'
import FotoPendukung from '../../../components/webcam/FotoPendukung'
import FotoPendukungTipeBarang from '../../../components/webcam/FotoPendukungTipeBarang'
import ModalWebCam from '../../../components/webcam/ModalWebCam'
import ModalPreview from '../../../components/webcam/ModalPreview'

export default {
    name: 'input-tipe-barang',
    components: {
        Kondisi,
        HargaTahun,
        HargaTahunNonAktif,
        EditFotoTipeBarang,
        FotoPendukung,
        ModalWebCam,
        ModalPreview,
        FotoPendukungTipeBarang
    },
    data() {
        return {
            id: null,
            initStatus: 0,
            isSubmitting: false,
            isBusy: true,
            input: {
                tipeBarang: "",
                merkBarang: null,
                jenisBarang: null,
                kelompok: null,
                hargaTipeBarang: null,
                statusBarang: true,
                kondisi: [],
                hargaTahun: [],
                nonAktifHargaTahun: [],
                fotoPendukung: [],
                filePDF: null,
                filePDFTahun: null,
                filePDFKondisi: null,
                berat: null,
                hargaBarangBaru:0
            },

            activeId:null,

            fields: [
                { key: "name", label: "Grade Barang", sortable: true },
                { key: "klasifikasi", label: "Klasifikasi", sortable: true },
                { key: "hargaMaksimal", label: "Harga Maksimal", sortable: true },
                { key: "nominalAngka", label: "Nominal Angka", sortable: true },
                { key: "nominalPersen", label: "Nominal Persen", sortable: true },
                { key: "keterangan", label: "Keterangan", sortable: true },
            ],

            kondisiBarang: [],
            hargaSesuaiTahun: false,
            kondisiSesuaiMerk: true,
            jenisBarang: [],
            merkBarang: [],
            indexKondisi: 2,
            indexHargaTahun: 2,
            isKendaraan: false,
            disabled: false,
            deleteHargaTahun: [],
            deleteKondisi: [],
            deleteFotoId: [],
            hargaTahunNonAktif: [],
            modalConfirmNonAktif: {},
            modalConfirmAktif: {},
            modalConfirmRemove: {},
            
            panduanNamaTipe:null,

            optKelompok: [],
            fotoTipe: [],

            indexFotoPendukung: 0,
            fotoPendukungError: false,
            activeFotoPendukungIndex: null,
            activeFotoPreviewIndex: null,
            minLengthFotoPendukung: 0,
            activeFotoPreview: "",

            foto: [],

             pdf: {
                urlPDF : {
                    fileList:[]
                }
            },
            pdf1: {
                urlPDF : {
                    fileList:[]
                }
            },
            pdf2: {
                urlPDF : {
                    fileList:[]
                }
            },
            url : [],
            url1 : [],
            url2 : [],

            pdfKondisi: {
                urlPDF : {
                    fileList:[]
                }
            },
            urlKondisi : [],


            pdfRecords:[],
            pdfNewVal:[],

            pdfRecords1:[],
            pdfNewVal1:[],

            pdfRecords2:[],
            pdfNewVal2:[],

            hapusSE:[],

            pdfRecordsKon:[],
            pdfNewValKon:[],
            activePdfPreview:""

        }
    },
    methods: {

        //----------------- Fungsi Inisialisasi -----------------

        init() {
            this.id = this.$route.params.id
            this.input.hargaTahun = []
            this.hargaTahunNonAktif = []

            let getKelompokBarang = this.$axios.get("barang-kelompok/selection").then(res => {
                this.optKelompok = res.data
                this.optKelompok.unshift({ id: 0, name: "Tidak ada kelompok" })
            })

            let getJenisBarang = this.$axios.get("barang-jenis/").then(response => {
                this.jenisBarang = response.data
            })

            let getSingleTipeBarang = this.$axios.get(`barang-tipe-v2/${this.id}`).then(response => {
                this.tipeBarang = response.data
                
                if(this.tipeBarang.suratEdaran.length != 0){
                    for(var file of this.tipeBarang.suratEdaran){
                        if(file.jenis == "tipe" || file.jenis == null){
                                this.url.push({
                                id: file.id,
                                url:file.filepath,
                            })
                        }
                        if(file.jenis == "tahun"){
                                this.url1.push({
                                id: file.id,
                                url:file.filepath,
                            })
                        }
                        if(file.jenis == "kondisi"){
                                this.url2.push({
                                id: file.id,
                                url:file.filepath,
                            })
                        }
                    }

                }

                //------------------ Inisialisasi foto tipe barang --------------------
                this.fotoTipe = response.data.foto
                this.fotoLength = response.data.foto.length
                for (var x of response.data.foto) {
                    this.input.fotoPendukung.push({
                        index: this.indexFotoPendukung,
                        id: x.id,
                        checkFotoBarangPendukung: false,
                        fotoBarangPendukungPlaceholder: 'Choose a file',
                        fotoBarangPendukung: null,
                        fotoBarangPendukungBase64: this.$baseFilePath + x.name,
                        activeFotoPendukungBase64: this.$baseFilePath + x.name,

                        isEdit: false
                    })
                    this.foto.push({
                        id: x.id,
                        index: this.indexFotoPendukung,
                        foto: this.$baseFilePath + x.name,

                        isEdit: false
                    })

                    this.indexFotoPendukung++;
                }

                //----------------- Inisialisasi Data Tipe Barang -----------------

                this.input.tipeBarang = this.tipeBarang.name
                this.input.jenisBarang = this.tipeBarang.jenis.id
                this.input.merkBarang = this.tipeBarang.merk.id
                this.input.statusBarang = this.tipeBarang.isActive
                this.input.hargaBarangBaru = this.$helper.addThousandSeparator(this.tipeBarang.hargaBarangBaru)

                if(this.tipeBarang.berat != null){
                    this.input.berat = this.tipeBarang.berat
                }

                if (this.tipeBarang.kelompok.name == null) {
                    this.input.kelompok = { id: 0, name: "Tidak ada kelompok" }
                }
                else {
                    this.input.kelompok = this.tipeBarang.kelompok
                }

                if (this.tipeBarang.jenis.name == "Mobil" || this.tipeBarang.jenis.name == "Motor") {
                    this.isKendaraan = true
                    this.hargaSesuaiTahun = true
                    this.disabled = true
                }
                else if (this.tipeBarang.hasTahun) {
                    this.hargaSesuaiTahun = true
                }

                if (this.tipeBarang.hasTahun == true) {
                    this.$axios.get(`barang-tipe-v2/barang-tahun/` + this.$route.params.id).then(response => {
                        let datas = response.data
                        this.input.hargaTahun = []
                        this.hargaTahunNonAktif = []

                        this.input.hargaTahun = []
                        for (var x of datas) {
                            if (x.isActive == true) {
                            
                            
                                //Elektronik
                                if(this.isKendaraan == false){
                                    this.input.hargaTahun.push({
                                    index: this.indexHargaTahun,
                                    id: x.id,
                                    selectedTahun: x.tahun,
                                    harga: this.$helper.addThousandSeparator(x.harga),
                                    isActive: x.isActive
                                    })
                                }
                                //Kendaraan
                                if(this.isKendaraan == true){
                                    this.input.hargaTahun.push({
                                        
                                    index: this.indexHargaTahun,
                                    id: x.id,
                                    selectedTahun: x.tahun,
                                    hargaKendaraan: this.$helper.addThousandSeparator(x.hargaKendaraan),
                                    hargaBpkb: this.$helper.addThousandSeparator(x.hargaBpkb),
                                    isActive: x.isActive
              
                                    })
                                }
                                
                               
                            } else if (x.isActive == false) {
                                // this.hargaTahunNonAktif.push({
                                //     index: this.indexHargaTahun,
                                //     id: x.id,
                                //     selectedTahun: x.tahun,
                                //     harga: this.$helper.addThousandSeparator(x.harga),
                                //     isActive: x.isActive
                                // })

                                 //Elektronik
                                
                                if(this.isKendaraan == false){
                                    this.hargaTahunNonAktif.push({
                                    index: this.indexHargaTahun,
                                    id: x.id,
                                    selectedTahun: x.tahun,
                                    harga: this.$helper.addThousandSeparator(x.harga),
                                    isActive: x.isActive
                                    })
                                }
                                //Kendaraan
                                if(this.isKendaraan == true){
                                    this.hargaTahunNonAktif.push({
                                        
                                    index: this.indexHargaTahun,
                                    id: x.id,
                                    selectedTahun: x.tahun,
                                    hargaKendaraan: this.$helper.addThousandSeparator(x.hargaKendaraan),
                                    hargaBpkb: this.$helper.addThousandSeparator(x.hargaBpkb),
                                    isActive: x.isActive
              
                                    })
                                }
                            }

                            this.indexHargaTahun++
                        }

                        // for (var x of response.data) {
                        //     if (x.isActive == true) {
                        //         this.optElekTahun.push({
                        //             id: x.id,
                        //             name: x.tahun
                        //         })
                        //     }
                        // }
                    })


                    //DEFAULT
                    // for (var x of this.tipeBarang.tahun) {
                    //     if (this.tipeBarang.jenis.name == "Mobil" || this.tipeBarang.jenis.name == "Motor") {
                    //         if (x.isActive == true) {
                    //             this.input.hargaTahun.push({
                    //                 index: this.indexHargaTahun,
                    //                 id: x.id,
                    //                 selectedTahun: x.tahun,
                    //                 hargaKendaraan: this.$helper.addThousandSeparator(x.hargaKendaraan),
                    //                 hargaBpkb: this.$helper.addThousandSeparator(x.hargaBpkb),
                    //                 isActive: x.isActive
                    //             })
                    //         } else if (x.isActive == false) {
                    //             this.hargaTahunNonAktif.push({
                    //                 index: this.indexHargaTahun,
                    //                 id: x.id,
                    //                 selectedTahun: x.tahun,
                    //                 hargaKendaraan: this.$helper.addThousandSeparator(x.hargaKendaraan),
                    //                 hargaBpkb: this.$helper.addThousandSeparator(x.hargaBpkb),
                    //                 isActive: x.isActive
                    //             })
                    //         }
                    //     }
                    //     else {
                    //         if (x.isActive == true) {
                    //             this.input.hargaTahun.push({
                    //                 index: this.indexHargaTahun,
                    //                 id: x.id,
                    //                 selectedTahun: x.tahun,
                    //                 harga: this.$helper.addThousandSeparator(x.harga),
                    //                 isActive: x.isActive
                    //             })
                    //         } else if (x.isActive == false) {
                    //             this.hargaTahunNonAktif.push({
                    //                 index: this.indexHargaTahun,
                    //                 id: x.id,
                    //                 selectedTahun: x.tahun,
                    //                 harga: this.$helper.addThousandSeparator(x.harga),
                    //                 isActive: x.isActive
                    //             })
                    //         }
                    //     }
                    //     this.indexHargaTahun++
                    // }
                }
                else {
                    this.input.hargaTipeBarang = this.$helper.addThousandSeparator(this.tipeBarang.harga)
                }

                if (this.tipeBarang.kondisi.length != 0) {
                    let nameMerk, ketMerk, namaSendiriMerk, dusMerk, detailInfoMerk, hargaMaksimalMerk = null
                    this.kondisiSesuaiMerk = false

                    for (var x of this.tipeBarang.kondisi) {
                        nameMerk = x.name
                        ketMerk = x.keterangan
                        hargaMaksimalMerk = this.$helper.addThousandSeparator(x.hargaMaksimal)
                        let nominalPMerk, nominalAMerk = null

                        if (x.dus == null) {
                            if (x.namaSendiri == true) namaSendiriMerk = 0
                            else namaSendiriMerk = 1
                        }
                        else {
                            if (x.dus == true) dusMerk = 0
                            else dusMerk = 1
                        }

                        if (x.nominalAngka == null) {
                            detailInfoMerk = "persen",
                                nominalPMerk = x.nominalPersen
                        }
                        else {
                            detailInfoMerk = "nominal",
                                nominalAMerk = this.$helper.addThousandSeparator(x.nominalAngka)
                        }

                        if (dusMerk == null) dusMerk = 0
                        if (namaSendiriMerk == null) namaSendiriMerk = 0

                        // let url = []
                        // for(var file of x.suratEdaran){
                        //         url.push({
                        //         id: file.id,
                        //         url:file.filepath,
                        //     })
                        // }

                        this.input.kondisi.push({
                            index: this.indexKondisi,
                            id: x.id,
                            name: nameMerk,
                            keterangan: ketMerk,
                            dus: dusMerk,
                            namaSendiri: namaSendiriMerk,
                            detailInfo: detailInfoMerk,
                            nominalPersen: nominalPMerk,
                            nominalAngka: nominalAMerk,
                            hargaMaksimal: hargaMaksimalMerk,
                            filePDF: [],
                        })
                        this.indexKondisi++
                    }
                }
            })

            Promise.all([getJenisBarang, getSingleTipeBarang, getKelompokBarang]).then(() => {
                this.initStatus = 1
                this.toggleBusy()
            })
                .catch(error => {
                    console.log(error)
                    this.initStatus = -1
                })
        },


        //----------------- Fungsi Tambah Hapus Data Harga/Tahun & Kondisi -----------------

        addHargaTahun() {
            this.input.hargaTahun.unshift({
                index: this.indexHargaTahun,
                id: 0,
                selectedTahun: null,
                tahun: null,
                harga: null,
                filePDF: []
            })
            this.indexHargaTahun++;
           
        },

        removeHargaTahun(index, id) {
            this.$bvModal.show("modal-confirm-hapus-tahun")
            this.modalConfirmRemove = {
                index: index,
                id: id
            }
        },

        onSubmitHapusHargaTahun() {
            this.$bvModal.hide("modal-confirm-hapus-tahun")
            this.input.hargaTahun = this.input.hargaTahun.filter(item => item.index != this.modalConfirmRemove.index)
            if (this.modalConfirmRemove.id != 0) {
                this.deleteHargaTahun.push(this.modalConfirmRemove.id)
            }
        },

        //----------------- Fungsi Non Aktif Harga Tahun -----------------

        nonAktifHargaTahun(index, id, hargaBpkb, hargaKendaraan, selectedTahun) {
            this.$bvModal.show("modal-confirm-non-aktif")
            this.activeId = id
            this.modalConfirmNonAktif = {
                'index': index,
                'id': id,
                'hargaBpkb': hargaBpkb,
                'hargaKendaraan': hargaKendaraan,
                'selectedTahun': selectedTahun
            }
        },

        onSubmitNonAktifHargaTahun() {
            let payloadNonAktif = new FormData()
            payloadNonAktif.append("id", this.modalConfirmNonAktif.id)
            payloadNonAktif.append("isActive", false)
        
            let idx = this.input.hargaTahun.findIndex(item => item.id == this.activeId)
            this.switchNonAktif(idx)
             this.input.hargaTahun = this.input.hargaTahun.filter(item => item.id != this.activeId)
           
            this.$bvModal.hide("modal-confirm-non-aktif")
        },

        async switchNonAktif(idx){
            await this.hargaTahunNonAktif.push(this.input.hargaTahun[idx])
        },

      


        //----------------- Fungsi Aktif Harga Tahun -----------------

        aktifHargaTahun(index, id) {
            this.$bvModal.show("modal-confirm-aktif")
            this.activeId = id
            // this.modalConfirmAktif = {
            //     'index': index,
            //     'id': id,
            //     'hargaBpkb': hargaBpkb,
            //     'hargaKendaraan': hargaKendaraan,
            //     'selectedTahun': selectedTahun
            // }
        },
        

        onSubmitAktifHargaTahun() {

            let payloadAktif = new FormData()
            payloadAktif.append("id", this.modalConfirmAktif.id)
            payloadAktif.append("isActive", true)

            let idx = this.hargaTahunNonAktif.findIndex(item => item.id == this.activeId)
            this.switchAktif(idx)
             this.hargaTahunNonAktif = this.hargaTahunNonAktif.filter(item => item.id != this.activeId)
            this.$bvModal.hide("modal-confirm-aktif")
        },
        async switchAktif(idx){
            await this.input.hargaTahun.push(this.hargaTahunNonAktif[idx])
        },

        addKondisi() {
            this.input.kondisi.unshift({
                index: this.indexKondisi,
                id: 0,
                name: "",
                dus: 0,
                namaSendiri: 0,
                keterangan: "",
                detailInfo: "persen",
                nominalPersen: null,
                nominalAngka: null,
                hargaMaksimal: 0
            })
            this.indexKondisi++;
        },

        removeKondisi(index, id) {
            this.$bvModal.show("modal-confirm-hapus-kondisi")
            this.modalConfirmRemove = {
                index: index,
                id: id
            }
        },

        onSubmitHapusKondisi() {
            this.$bvModal.hide("modal-confirm-hapus-kondisi")
            this.input.kondisi  = this.input.kondisi.filter(item => item.index != this.modalConfirmRemove.index)
            if(this.modalConfirmRemove.id != 0){
                this.deleteKondisi.push(this.modalConfirmRemove.id)
            }
            // this.deleteKondisi.push(this.modalConfirmRemove.id)
        },

        //----------------- Fungsi Tambah Hapus Data Foto Pendukung -----------------

        addFotoPendukung() {
            if (this.input.fotoPendukung.length < 6) {

                this.input.fotoPendukung.push({
                    id: 0,
                    index: this.indexFotoPendukung,
                    checkFotoBarangPendukung: false,
                    fotoBarangPendukungPlaceholder: 'Choose a file',
                    fotoBarangPendukung: null,
                    fotoBarangPendukungBase64: null,
                    activeFotoPendukungBase64: null,
                    isNew: true
                })

                this.foto.push({
                    index: this.indexFotoPendukung,
                    foto: null,
                    isNew: true
                })

                this.indexFotoPendukung++
            } else {
                this.fotoPendukungError = true;
            }
        },

        removeFotoPendukung(index) {
            this.$bvModal.show("modal-confirm-hapus-foto")
            this.modalConfirmRemove = index
        },

        onSubmitRemoveFoto() {

            for (var x of this.foto) {
                if (x.index == this.modalConfirmRemove.index) {
                    x.foto = ""
                    this.deleteFotoId.push(this.modalConfirmRemove.id)
                }
            }

            this.input.fotoPendukung = this.input.fotoPendukung.filter(item => item.index != this.modalConfirmRemove.index)
            this.$bvModal.hide("modal-confirm-hapus-foto")

            this.fotoPendukungError = false
        },

        //-------------- Fungsi Lain ------------------------------

        openModalCam(index) {
            this.activeFotoPendukungIndex = index
            this.$bvModal.show("webcam-input-elek")
        },

        openModalPreview(index) {
          
            this.activeFotoPreviewIndex = index
            let idx = this.input.fotoPendukung.findIndex(item => item.index == this.activeFotoPreviewIndex);
            this.activeFotoPreview = this.input.fotoPendukung[idx].fotoBarangPendukungBase64
            this.$bvModal.show("modal-preview-gadai")
        },

        async setResult(result) {
            //letakin ke null masing2
            var newResult = await this.$helper.resizeImage(result)
            let idx = this.input.fotoPendukung.findIndex(item => item.index == this.activeFotoPendukungIndex);
            this.input.fotoPendukung[idx].fotoBarangPendukungBase64 = newResult
            this.input.fotoPendukung[idx].activeFotoPendukungBase64 = newResult
            this.input.fotoPendukung[idx].fotoBarangPendukungPlaceholder = "Foto dari Kamera"
            this.input.fotoPendukung[idx].checkFotoBarangPendukung = true
            this.input.fotoPendukung[idx].isCamera = true
            this.foto[idx].foto = newResult
        },


        //----------------- Fungsi Submit Data -----------------

        onSubmit() {
        
            //----------------- Submit Semua Data -----------------

            let json = 
            {
                "id": this.id,
                "name": this.input.tipeBarang,
                "merkId": this.input.merkBarang,
                "isActive": this.input.statusBarang,
                "hargaBarangBaru": this.$helper.removeThousandSeparator(this.input.hargaBarangBaru),
                "kelompokId": this.input.kelompok.id,
                "berat": (this.$helper.isNullOrEmpty(this.input.berat)) ?null :this.input.berat
            }
            this.isSubmitting = true
            this.$axios.post("barang-tipe-v2/update-data-umum", json).then(() => {
                this.$helper.setFlash(`Tipe barang telah berhasil diubah!`)
                let path = this.$route.path.split("/")
                path.pop()
                path = path.join("/")
                this.$router.push({ path })
            })
                .catch(error => {
                    console.log(error)
                    console.log(error.response.data.reason)
                    this.$helper.parseError(this, error)
                })
                .finally(() => {
                    this.isSubmitting = false
                })

        },


        //----------------- Fungsi Lain -----------------

        openModalConfirm() {

            if(this.input.filePDF != null){
            for(var file of this.input.filePDF){
                   
                    if(file.type != null){
                            if(file.type != "application/pdf" ){
                            this.$helper.toastErr(this, 'file '+file.name+' bukan PDF')
                            return
                        }
                    }else{
                            if(file.file.type != "application/pdf"){
                            this.$helper.toastErr(this, 'file '+file.name+' bukan PDF')
                            return
                        }
                    } 
                }
            }

            if(this.input.filePDFTahun != null){
            for(var file of this.input.filePDFTahun){
        
                    if(file.type != null){
                            if(file.type != "application/pdf" ){
                            this.$helper.toastErr(this, 'file '+file.name+' bukan PDF')
                            return
                        }
                    }else{
                            if(file.file.type != "application/pdf"){
                            this.$helper.toastErr(this, 'file '+file.name+' bukan PDF')
                            return
                        }
                    } 
                }
            }

            if(this.input.filePDFKondisi != null){
            for(var file of this.input.filePDFKondisi){
                
                    if(file.type != null){
                            if(file.type != "application/pdf" ){
                            this.$helper.toastErr(this, 'file '+file.name+' bukan PDF')
                            return
                        }
                    }else{
                            if(file.file.type != "application/pdf"){
                            this.$helper.toastErr(this, 'file '+file.name+' bukan PDF')
                            return
                        }
                    } 
                }
            }
        
            // if (this.hargaSesuaiTahun == true && this.input.hargaTahun.length == 0) {
            //     this.$helper.toastErr(this, "Tolong masukkan minimal data 1 tahun")
            // }
            // else if (this.kondisiSesuaiMerk == false && this.input.kondisi.length == 0) {
            //     this.$helper.toastErr(this, "Tolong masukkan minimal 1 kondisi")
            // }
            // else {
            // }
            this.$bvModal.show("modal-confirm-edit")
        },

        toggleBusy() {
            if (this.isBusy == true) this.isBusy = false
            else this.isBusy = true
        },

        //----------------- Fungsi SE Spesifikasi -----------------
        changeSEHargaTahun(idTahun,filePDF){
            let idx = this.input.hargaTahun.findIndex(item => item.id == idTahun)
            this.input.hargaTahun[idx].filePDF = filePDF
        },

        openModalPreviewPDFTahunKondisi(base64){
            this.activePdfPreview = base64
            this.$bvModal.show("modal-SE")
        },

        changeSEKon(idKondisi,filePDF){
            let idx = this.input.kondisi.findIndex(item => item.id == idKondisi)
            this.input.kondisi[idx].filePDF = filePDF
        },

        removeSE(){
             for(var file of this.pdf.urlPDF.files){

               let idx = this.pdfNewVal.findIndex(item => item.name == file.name)
               if(idx == -1){
                if(file.path.id != undefined){
                    this.hapusSE.push(file.path.id)
                }
               }
            }

            this.pdf.urlPDF.files = this.pdfNewVal
            this.pdfRecords = this.pdfNewVal
            this.$bvModal.hide("modal-hapus-se")
        },

        removeSETahun(){

            for(var file of this.pdf1.urlPDF.files){
               let idx = this.pdfNewVal1.findIndex(item => item.name == file.name)
               if(idx == -1){
                if(file.path.id != undefined){
                    this.hapusSE.push(file.path.id)
                }
               }
            }

            this.pdf1.urlPDF.files = this.pdfNewVal1
            this.pdfRecords1 = this.pdfNewVal1
            this.$bvModal.hide("modal-hapus-se-tahun")
        },

        removeSEKondisi(){

            for(var file of this.pdf2.urlPDF.files){
               let idx = this.pdfNewVal2.findIndex(item => item.name == file.name)
               if(idx == -1){
                if(file.path.id != undefined){
                    this.hapusSE.push(file.path.id)
                }
               }
            }

            this.pdf2.urlPDF.files = this.pdfNewVal2
            this.pdfRecords2 = this.pdfNewVal2
            this.$bvModal.hide("modal-hapus-se-kondisi")
        },


        roundPersen(){
            var desimalBerat = Number(this.input.berat).toFixed(2);
			this.input.berat = desimalBerat;
		},


    },

    watch: {

        //----------------- Pantau Jenis Barang -----------------

        'input.jenisBarang': function (id) {
            this.kondisiBarang = []
            this.$axios.get(`barang-merk/jenis/${id}`).then(response => {
                this.merkBarang = response.data
            })
                .catch(error => {
                    console.log(error)
                    console.log(error.response.data.reason)
                    this.$helper.parseError(this, error)
                })

            this.$axios.get(`barang-jenis/panduan-nama-tipe/${id}`).then(response => {
            this.panduanNamaTipe = response.data
            if (this.isBusy == true) this.toggleBusy()
            })
            .catch(error => {
            console.log(error)
            console.log(error.response.data.reason)
            this.$helper.parseError(this, error)
            if (this.isBusy == true) this.toggleBusy()
            })

            let jenis = this.jenisBarang.filter(item => item.id == id)
            if (jenis === undefined) {
                let namaJenis = jenis[0].jenisPinjaman.name
                if (namaJenis == 'Kendaraan') {
                    this.isKendaraan = true
                    this.hargaSesuaiTahun = true
                    this.disabled = true
                }
                else if (namaJenis == 'Elektronik') {
                    this.isKendaraan = false
                    this.disabled = false
                }
            }
        },


        //----------------- Pantau Merk Barang -----------------

        'input.merkBarang': function (id) {
            this.$axios.get(`barang-merk/kondisi/${id}`).then(response => {
                this.kondisiBarang = response.data
            })
                .catch(error => {
                    console.log(error)
                    console.log(error.response.data.reason)
                    this.$helper.parseError(this, error)
                })
        },
        "input.hargaTipeBarang": function (newValue) {
            if (newValue.length > 1 && newValue.charAt(0) == 0) {
                newValue = parseFloat(newValue).toString()
            }
            let cleanValue = this.$helper.changeToValue(newValue);
            const result = cleanValue.replace(/(?!^-)[^0-9]/g, "")
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            this.$nextTick(() => this.input.hargaTipeBarang = result);
        },
        "input.hargaBarangBaru": function (newValue) {
            if (newValue.length > 1 && newValue.charAt(0) == 0) {
                newValue = parseFloat(newValue).toString()
            }
            let cleanValue = this.$helper.changeToValue(newValue);
            const result = cleanValue.replace(/(?!^-)[^0-9]/g, "")
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            this.$nextTick(() => this.input.hargaBarangBaru = result);
        },

        "hargaSesuaiTahun": function (val) {
            if (val == true) {
                this.$axios.get(`barang-tipe-v2/barang-tahun/` + this.$route.params.id).then(response => {
            
                    this.input.hargaTahun = []
                    this.hargaTahunNonAktif = []

                    let datas = response.data
                    for (var x of datas) {
                        if (x.isActive == true) {
                            
                          
                            //Elektronik
                            if(this.isKendaraan == false){
                               
                                this.input.hargaTahun.push({
                                index: this.indexHargaTahun,
                                id: x.id,
                                selectedTahun: x.tahun,
                                harga: this.$helper.addThousandSeparator(x.harga),
                                isActive: x.isActive
                                })
                            }
                            //Kendaraan
                            if(this.isKendaraan == true){
                             
                                this.input.hargaTahun.push({
                                    
                                index: this.indexHargaTahun,
                                id: x.id,
                                selectedTahun: x.tahun,
                                hargaKendaraan: this.$helper.addThousandSeparator(x.hargaKendaraan),
                                hargaBpkb: this.$helper.addThousandSeparator(x.hargaBpkb),
                                isActive: x.isActive
          
                                })
                            }
                            
                           
                        } else if (x.isActive == false) {
                            // this.hargaTahunNonAktif.push({
                            //     index: this.indexHargaTahun,
                            //     id: x.id,
                            //     selectedTahun: x.tahun,
                            //     harga: this.$helper.addThousandSeparator(x.harga),
                            //     isActive: x.isActive
                            // })

                             //Elektronik
                         
                            if(this.isKendaraan == false){
                             
                                this.hargaTahunNonAktif.push({
                                index: this.indexHargaTahun,
                                id: x.id,
                                selectedTahun: x.tahun,
                                harga: this.$helper.addThousandSeparator(x.harga),
                                isActive: x.isActive
                                })
                            }
                            //Kendaraan
                            if(this.isKendaraan == true){
                                this.hargaTahunNonAktif.push({
                                    
                                index: this.indexHargaTahun,
                                id: x.id,
                                selectedTahun: x.tahun,
                                hargaKendaraan: this.$helper.addThousandSeparator(x.hargaKendaraan),
                                hargaBpkb: this.$helper.addThousandSeparator(x.hargaBpkb),
                                isActive: x.isActive
          
                                })
                            }
                        }


                        this.indexHargaTahun++
                    }

                    // for (var x of response.data) {
                    //     if (x.isActive == true) {
                    //         this.optElekTahun.push({
                    //             id: x.id,
                    //             name: x.tahun
                    //         })
                    //     }
                    // }
                })
            }
        },

          "pdf.urlPDF.files" : function(newVal){
            //Hapus SE
            if(this.pdfRecords.length > newVal.length){
               
                this.pdf.urlPDF.files = this.pdfRecords
                this.pdfNewVal = newVal
                this.$bvModal.show("modal-hapus-se")
            }
            //Tambah SE
            else {
            let pdf = []
            for(var file of this.pdf.urlPDF.files){
                pdf.push(file)
            }
            this.input.filePDF = pdf
            this.pdfRecords = pdf
            }

        },

        "pdf.file.fileList" : function(){
            let Pdfbase64 = []
            for(var file of this.pdf.file.fileList){
                Pdfbase64.push(file)
            }
            this.input.filePDF = Pdfbase64
        },

        "pdf1.urlPDF.files" : function(newVal){
            //Hapus SE
            if(this.pdfRecords1.length > newVal.length){
                this.pdf1.urlPDF.files = this.pdfRecords1
                this.pdfNewVal1 = newVal
                this.$bvModal.show("modal-hapus-se-tahun")
            }
            //Tambah SE
            else {
            let pdf = []
            for(var file of this.pdf1.urlPDF.files){
                pdf.push(file)
            }
            this.input.filePDFTahun = pdf
            this.pdfRecords1 = pdf
            }

        },

        "pdf1.file.fileList" : function(){
            let Pdfbase64 = []
            for(var file of this.pdf1.file.fileList){
                Pdfbase64.push(file)
            }
            this.input.filePDFTahun = Pdfbase64
        },

        "pdf2.urlPDF.files" : function(newVal){
            //Hapus SE
            if(this.pdfRecords2.length > newVal.length){
                this.pdf2.urlPDF.files = this.pdfRecords2
                this.pdfNewVal2 = newVal
                this.$bvModal.show("modal-hapus-se-kondisi")
            }
            //Tambah SE
            else {
            let pdf = []
            for(var file of this.pdf2.urlPDF.files){
                pdf.push(file)
            }
            this.input.filePDFKondisi = pdf
            this.pdfRecords2 = pdf
            }

        },

        "pdf2.file.fileList" : function(){
            let Pdfbase64 = []
            for(var file of this.pdf2.file.fileList){
                Pdfbase64.push(file)
            }
            this.input.filePDFKondisi = Pdfbase64
        },

    },

    created() {
        this.init()
    }
}
</script>
